import { Component, Inject, OnInit, Optional } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FulFillment } from '../../../models/common/trading-common.model';
import { MutualFundTradingService } from '../../../services/mutualfund/mutualfund-trading-service.service';
import { createOrderProspectusForm } from '../../../utils';
import { TRADING_PLATFORM } from '../../../utils/trading-constants';

import states from './states_titlecase.json';

@Component({
  selector: 'order-prospectus-form',
  templateUrl: './order-prospectus-form.component.html',
  styleUrls: ['./order-prospectus-form.component.css']
})
export class OrderProspectusFormComponent implements OnInit {

  showErrorMessage = false;
  showConfirmMessage = false;
  submitInProgress = false;
  orderProspectusForm: FormGroup;

  usStates: any[];

  constructor(
    private mutualFundTradingService: MutualFundTradingService,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<OrderProspectusFormComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit() {
    this.usStates = states;
    this.orderProspectusForm = createOrderProspectusForm(this.fb);
  }

  closeDialog() {
    this.dialogRef.close();
  }

  submitProspectusOrder() {
    let formVal = this.orderProspectusForm.getRawValue();
    let reqPayload: FulFillment = {} as FulFillment;
    if (this.data && this.data.quote) {
      reqPayload.cusipId = this.data.quote.cusipId;
      reqPayload.symId = this.data.quote.symId;

    }
    Object.assign(reqPayload, formVal);

    reqPayload.dayPhnNum = reqPayload.dayPhnNum.replace(/\D/g,'');
    reqPayload.evePhnNum = reqPayload.evePhnNum.replace(/\D/g,'');

    this.submitInProgress = true;
    this.mutualFundTradingService.sendProspectusRequest(TRADING_PLATFORM.RETAIL, reqPayload).subscribe(
      (resp) => this.successCallback(resp),
      (error) => this.handleError(error)
    );
  }

  successCallback(resp) {
    this.submitInProgress = false;
    if ( resp && resp.errorCode === 0 && resp.response && resp.response.hostReturnCode === 0) {
      this.showConfirmMessage = true;
    } else {
      this.showErrorMessage = true;
    }
  }

  handleError(err) {
    this.submitInProgress = false;
    this.showErrorMessage = true;
  }

  // Form Controls
  firstNme(): AbstractControl {
    return this.orderProspectusForm.get('firstNme');
  }

  lastNme(): AbstractControl {
    return this.orderProspectusForm.get('lastNme');
  }

  addrTxt1(): AbstractControl {
    return this.orderProspectusForm.get('addrTxt1');
  }

  addrTxt2(): AbstractControl {
    return this.orderProspectusForm.get('addrTxt2');
  }

  cityNme(): AbstractControl {
    return this.orderProspectusForm.get('cityNme');
  }

  stateCd(): AbstractControl {
    return this.orderProspectusForm.get('stateCd');
  }

  zipCd(): AbstractControl {
    return this.orderProspectusForm.get('zipCd');
  }

  dayPhnNum(): AbstractControl {
    return this.orderProspectusForm.get('dayPhnNum');
  }

  evePhnNum(): AbstractControl {
    return this.orderProspectusForm.get('evePhnNum');
  }
}
